/**
 * What a reading Exercise 阅读练习 says to a learner. The right option is
 * marked in the list under the line, so the line never repeats it.
 *
 * Qing Wang asked for friendlier marks and a clearer finish (CB-41, CB-73),
 * and the lines were rewritten with Codex on 2026-10-27 from her suggestions. They
 * part from the grammar exercise's Correct 对 and Incorrect 不对
 * (`./lianxi-yufa-copy.ts`), which her issue did not cover. The miss and the
 * hand-over were worded again with Codex on 2026-11-02 (CB-121), once the
 * label on the right option said what the miss line used to.
 */
export const yueduCopy = {
  /** The line over the questions saying where the reader is. */
  progress: (at: number, of: number): string =>
    `Question ${String(at)} of ${String(of)}`,

  /** Enter pressed with no option chosen. */
  chooseFirst: "Choose an answer first.",

  right: "Correct! 答对了！",
  wrong: "Not quite. 不太对。",

  /** The score at the finish, large: how many were right. */
  score: (right: number, of: number): string =>
    `${String(right)} out of ${String(of)}`,

  /** The share right, quieter beside the score (CB-73). */
  share: (right: number, of: number): string =>
    `${String(of === 0 ? 0 : Math.round((right / of) * 100))}% correct`,

  /** What a numbered button in the review says of its question. */
  reviewRight: (at: number): string =>
    `Question ${String(at)}, answered correctly`,
  reviewWrong: (at: number): string =>
    `Question ${String(at)}, answered incorrectly`,

  /** What the finish adds once the words are in 复习, where the cards were not counted. */
  handedOver: "Words from this passage are in Review.",

  /**
   * What went into 复习, where the cards were counted. Every card is new and
   * comes from the passage's words, several to a word (CB-73), so the count
   * is far more than the New Words list and the line says why (CB-121).
   */
  added: (cards: number): string =>
    cards === 1
      ? "Added 1 new card to Review for a word from this passage."
      : `Added ${String(cards)} new cards to Review for words from this passage, with several cards per word.`,

  /**
   * The link into 复习 after the hand-over, which opens the learner's whole
   * queue rather than this passage's cards alone (CB-121).
   */
  startReviewing: "Open your Review",

  /*
   * The written reply's lines (CB-77) were worded with Codex on 2026-10-27.
   */

  /** Check pressed on a written reply with nothing written. */
  writeFirst: "Type a reply first.",

  /** A written reply that is a checked one in the other writing. */
  replyOther: "Correct! You used the other script. 答对了！",

  /** A known wrong reply, with the reviewed note on it. */
  replyKnown: (why: string): string => `Not quite. ${why}`,

  /** A reply nobody has checked, which is never called wrong. */
  replyUnchecked: "We haven't checked this reply, so we can't mark it.",

  /** After a first reply that missed: the second try. */
  tryAgain: "Have another go with the hint.",

  /** After a second reply that missed: the checked replies to compare. */
  compare: "Compare your reply with the examples.",

  /** What a numbered button in the review says of an unchecked reply. */
  reviewUnchecked: (at: number): string =>
    `Question ${String(at)}, reply not checked`,

  /** Beside the score, the replies left out of it (CB-77). */
  uncheckedNote: (count: number): string =>
    `${count === 1 ? "1 unchecked reply" : `${String(count)} unchecked replies`} left out of your score.`,
} as const;
